export default __webpack_public_path__ + "static/media/10.1f962dea.jpg";